import { getEditItems } from "./editStore";
import { getEditFeaturesMap } from "./editFeaturesStore";

export function getEditImageSummary(editId) {
  if (!editId) return null;

  const pins = getEditItems(editId) || [];
  const featureMap = getEditFeaturesMap(editId) || {};

  const imagePins = pins.filter((p) => String(p?.kind || "").toLowerCase() === "image");
  if (!imagePins.length) return null;

  const extracted = imagePins
    .map((p) => featureMap[p.id]?.features)
    .filter((f) => f && Array.isArray(f.items) && f.palette);

  if (!extracted.length) return null;

  const famScore = new Map();
  const strategyScore = new Map();

  for (const f of extracted) {
    const pal = f.palette || {};
    const conf = typeof pal.confidence === "number" ? pal.confidence : 0.5;

    for (const c of pal.dominant_families || []) famScore.set(c, (famScore.get(c) || 0) + 2 * conf);
    for (const c of pal.accent_families || []) famScore.set(c, (famScore.get(c) || 0) + 1 * conf);

    if (pal.strategy) strategyScore.set(pal.strategy, (strategyScore.get(pal.strategy) || 0) + conf);
  }

  const families = [...famScore.entries()].sort((a, b) => b[1] - a[1]).map(([k]) => k).slice(0, 4);
  const strategy = [...strategyScore.entries()].sort((a, b) => b[1] - a[1])[0]?.[0] || null;

  const subtypeScore = new Map();
  for (const f of extracted) {
    for (const it of f.items || []) {
      const s = it?.subtype;
      const conf = typeof it?.confidence === "number" ? it.confidence : 0.5;
      if (s) subtypeScore.set(s, (subtypeScore.get(s) || 0) + conf);
    }
  }

  const garmentSubtypes = [...subtypeScore.entries()]
    .sort((a, b) => b[1] - a[1])
    .map(([k]) => k)
    .slice(0, 6);

  return {
    extractedCount: extracted.length,
    imagePinCount: imagePins.length,
    palette: { families, strategy },
    garmentSubtypes,
  };
}